<template>
    <div>
        <div v-if="areRequiredDataFilledIn">
            <h5 class="font-size">
                Share the generated campaign URL
            </h5>
            <p>
                Use this URL in any promotional channels you want to be associated with this custom campaign
            </p>
            <div class="d-flex flex-wrap flex-xl-nowrap">
                <div 
                    @click="showSuccess" 
                    class="script-tag mr-3 cursor-pointer"
                >
                    <d-form-text tag="h6" class="py-2 px-3 m-0 text-break">
                        {{ utmTag }}
                    </d-form-text>
                </div>
                <button 
                    type="button" 
                    @click="showSuccess" 
                    class="btn btn-success btn-sm mt-4 mt-xl-0 align-self-end"
                >
                    Copy to Clipboard
                </button>
            </div>
        </div>
        <div v-else>
            Fill out all the required fields above and a URL will be automatically generated for you here.
        </div>
    </div>
</template>

<script>
    import notification from '@/mixins/notification';
    export default {
        mixins: [notification],
        data() {
            return {
                utmTagData: {
                    url: '',
                    page: '',
                    source: '',
                    medium: '',
                    name: '',
                    term: '',
                    content: '',
                } 
            }
        },

        methods: {
            updateUtmTagData(utmTagData) {
                this.utmTagData = utmTagData;
            },

            showSuccess() {
                this.$clipboard(this.utmTag);
                this.showNotification('success', 'Alert', 'Copied to clipboard!');
            }
        },

        computed: {
            areRequiredDataFilledIn() {
                return !!(
                    this.utmTagData.url && 
                    this.utmTagData.source && 
                    this.utmTagData.medium && 
                    this.utmTagData.name
                );
            },
            utmTag() {
                const linkBuilder = [];
                let url = this.utmTagData.url;
                let page = '';

                if (this.utmTagData.source) {
                    linkBuilder.push(`utm_source=${encodeURIComponent(this.utmTagData.source)}`);
                }

                if (this.utmTagData.medium) {
                    linkBuilder.push(`utm_medium=${encodeURIComponent(this.utmTagData.medium)}`);
                }

                if (this.utmTagData.name) {
                    linkBuilder.push(`utm_campaign=${encodeURIComponent(this.utmTagData.name)}`);
                }

                if (this.utmTagData.term) {
                    linkBuilder.push(`utm_term=${encodeURIComponent(this.utmTagData.term)}`);
                }

                if (this.utmTagData.content) {
                    linkBuilder.push(`utm_content=${encodeURIComponent(this.utmTagData.content)}`);
                }

                if (this.utmTagData.url) {
                    const lastChar = this.utmTagData.url.charAt(this.utmTagData.url.length - 1);
                    if (lastChar !== '/') {
                        url = this.utmTagData.url.concat('/');
                    }
                }

                if (this.utmTagData.page) {
                    page = this.utmTagData.page.concat('/');
                }

                return `${url}${page}?${linkBuilder.join('&')}`;
            }
        },

        mounted() {
            this.$eventHub.$on('update-link-generator', this.updateUtmTagData);
        },

        beforeDestroy() {
            this.$eventHub.$off('update-link-generator', this.updateUtmTagData);
        }
    }
</script>